import React from 'react';
// Static info bar. No countdown or timers.
export function InfoBar() {
  return <div className="w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-180" data-mp="2fhuu8wr0zder">
      <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-medium sm:text-sm" data-id="element-181" data-mp="2fjpk8ph5lvpp">
        Direkte nedlasting · 7 dagers garanti
      </p>
    </div>;
}